/**
 * A simple implementation of an injection token, which can be used to register and lookup objects in the registry.
 *
 * The key is a string, which can be used to identify the object in the registry.
 * The injected type is a generic type, which can be used to specify the type of the object that is being registered or looked up.
 */
export class InjectionToken<_InjectedType = never> {

    constructor(
        public readonly key: string,
    ) { }

    toString(): string {
        return this.key;
    }
}
